import React, { useState, useEffect } from 'react';
import QRCode from 'qrcode';
import { QrCode, Download, Copy, Check } from 'lucide-react';

const ModuleBarcode = ({ moduleId, moduleTitle, baseUrl = window.location.origin }) => {
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState('');
  const [copied, setCopied] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);

  // Generate the URL that will redirect to login with module parameter
  const moduleUrl = `${baseUrl}/login?module=${moduleId}`;

  useEffect(() => {
    generateQRCode();
  }, [moduleId, baseUrl]);

  const generateQRCode = async () => {
    setIsGenerating(true);
    try {
      const qrCodeDataUrl = await QRCode.toDataURL(moduleUrl, {
        width: 300,
        margin: 2,
        color: {
          dark: '#000000',
          light: '#FFFFFF'
        },
        errorCorrectionLevel: 'M'
      });
      setQrCodeDataUrl(qrCodeDataUrl);
    } catch (error) {
      console.error('Error generating QR code:', error);
    } finally {
      setIsGenerating(false);
    }
  };

  const downloadQRCode = () => {
    if (qrCodeDataUrl) {
      const link = document.createElement('a');
      link.download = `${moduleId}-barcode.png`;
      link.href = qrCodeDataUrl;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const copyUrl = async () => {
    try {
      await navigator.clipboard.writeText(moduleUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      console.error('Failed to copy URL:', error);
    }
  };

  return (
    <div className="barcode-container">
      <div className="barcode-header">
        <div className="barcode-icon">
          <QrCode size={24} />
        </div>
        <h3 className="barcode-title">Module Barcode</h3>
        <p className="barcode-subtitle">{moduleTitle}</p>
      </div>

      <div className="barcode-content">
        {isGenerating ? (
          <div className="barcode-loading">
            <div className="loading-spinner"></div>
            <p>Generating barcode...</p>
          </div>
        ) : qrCodeDataUrl ? (
          <div className="barcode-display">
            <img 
              src={qrCodeDataUrl} 
              alt={`QR Code for ${moduleTitle}`}
              className="barcode-image"
            />
            <p className="barcode-instructions">
              Scan this barcode to access the training module
            </p>
          </div>
        ) : (
          <div className="barcode-error">
            <p>Failed to generate barcode</p>
            <button onClick={generateQRCode} className="btn btn-primary">
              Retry
            </button>
          </div>
        )}

        <div className="barcode-actions">
          <button 
            onClick={downloadQRCode}
            disabled={!qrCodeDataUrl}
            className="btn btn-secondary"
          >
            <Download size={16} />
            Download
          </button>
          
          <button 
            onClick={copyUrl}
            className="btn btn-secondary"
          >
            {copied ? <Check size={16} /> : <Copy size={16} />}
            {copied ? 'Copied!' : 'Copy URL'}
          </button>
        </div>

        <div className="barcode-url">
          <label className="url-label">Direct URL:</label>
          <div className="url-container">
            <input 
              type="text" 
              value={moduleUrl} 
              readOnly 
              className="url-input"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModuleBarcode;
